import { style } from "@vanilla-extract/css";

import { vars } from "~/styles/tokens.css";

// Task table shared by the case detail page and the document-uploads detail
// page — both are projects, so their task/review-gate rows render identically.

export const taskName = style({
  fontWeight: vars.fontWeight.semibold,
  color: vars.color.textDefault,
  // Anchor for the absolutely-positioned disclosure chevron so it sits in the
  // cell's left padding without shifting the task name — every row's name
  // stays on the same left edge whether or not it has a review card.
  position: "relative",
});

// Disclosure triangle that toggles a review-gate row's card. Absolutely placed
// in the cell's left padding (not in the text flow), so it adds no row height
// and doesn't indent the name. Points down when expanded; rotates to point
// right when collapsed (matches the workflow list editor).
export const chevron = style({
  position: "absolute",
  left: "3px",
  // Centered on the task-name's first line (measured line center ≈ 1.2rem from
  // the cell top); translateY(-50%) makes `top` the center point, so the glyph
  // size can change without re-tuning the offset.
  top: "1.2rem",
  transform: "translateY(-50%)",
  background: "none",
  border: "none",
  padding: 0,
  color: vars.color.textSubtle,
  fontSize: "0.75rem",
  lineHeight: 1,
  cursor: "pointer",
  transition: "transform 0.15s",
});

export const chevronCollapsed = style({
  transform: "translateY(-50%) rotate(-90deg)",
});

export const taskRole = style({
  color: vars.color.textMuted,
  fontSize: vars.fontSize.sm,
});

// Created / completed timestamps beneath the task name — secondary metadata,
// so it's the smallest, muted, and normal-weight to sit quietly under the row.
export const taskDates = style({
  marginTop: vars.space.xs,
  color: vars.color.textMuted,
  fontSize: vars.fontSize.xs,
  fontWeight: vars.fontWeight.regular,
});

// Expansion cell holding a verdict beneath its task row. No top padding so the
// panel sits flush under the row; the panel owns its inset.
export const proposalCell = style({
  paddingTop: 0,
  paddingBottom: vars.space.md,
});

export const actionsCell = style({
  textAlign: "right",
  width: "1%",
  whiteSpace: "nowrap",
});

// Holds the row's action buttons; a review task shows two (Mark done + Reject)
// side by side, every other task a single button. The exception gate shows an
// FV-project-id input + Assign button.
export const actionGroup = style({
  display: "inline-flex",
  gap: vars.space.sm,
  justifyContent: "flex-end",
  alignItems: "center",
});

export const gateInput = style({
  width: "10rem",
});
